@import '../../tokens/typography/index.css';

cobalt-button {
  display: flex;
}

cobalt-button:not([size="small"]) {
  --number-radius-medium: var(--number-radius-round);
  --number-radius-large: var(--number-radius-round);
}

